export default __webpack_public_path__ + "static/media/home-banner-animation.99edd888.gif";